<body class="ltr main-body leftmenu">
    <div class="main-content side-content pt-0 ml-0">
        <div class="main-container container-fluid">
            <div class="inner-body">
                <div class="row row-sm">
                    <div class="col-lg-12">
                        <div class="card custom-card">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-8">
                                        <div class=" d-flex align-items-center pl-3">
                                            <img alt="Logo" src="../../assets/img/ExamMaster.png" class="mh-45px pb-2">
                                            <div class="ml-2">
                                                <h3 class="main-content-label mb-1"><b>
                                                        WithHold Cases
                                                    </b></h3>
                                                <p class="text-muted card-sub-title mb-0">
                                                    WithHold Cases
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <hr class="mt-1 mb-2">
                                <div class="row row-sm add-form">
                                    <form autocomplete="off" class="p-0" novalidate [formGroup]="WithHoldForm">
                                        <div class="col-lg-12 col-md-12">
                                            <!-- <div class="card custom-card"> -->
                                            <!-- <div>
                                                        <h3 class="main-content-label mb-1"><b>
                                                                {{TitleTwo}}
                                                            </b></h3>
                                                        <p class="text-muted card-sub-title mb-0">
                                                            Add and Search {{TitleThree}}
                                                        </p>
                                                    </div> -->

                                            <div class="row clearfix">
                                                <div class="col-sm-3">
                                                    <div class="form-group">
                                                        <div class="">

                                                            <mat-form-field appearance="outline"
                                                                class="example-full-width">
                                                                <mat-label> List</mat-label>
                                                                <!-- (click)="getList(item.ListDesc)" <input class="input"  matInput formControlName="" placeholder="Exam" > -->
                                                                <mat-select required formControlName="list" #select23
                                                                    class="colorblack">
                                                                    <mat-select-filter [placeholder]="'Filter'"
                                                                        [displayMember]="'ListDesc'"
                                                                        [array]="ListOfEcId"
                                                                        (filteredReturn)=" filteredList =$event">
                                                                    </mat-select-filter>
                                                                    <mat-option *ngFor="let item of filteredList"
                                                                        [value]="item.EcId"
                                                                        (click)="fetchListForRgNo(item)">
                                                                        {{item.ListDesc}}
                                                                    </mat-option>
                                                                </mat-select>
                                                                <mat-error class="margin_tp"
                                                                    *ngIf="WithHoldForm.controls['list'].touched && WithHoldForm.controls['list'].errors?.required">
                                                                    Mandatory
                                                                </mat-error>
                                                            </mat-form-field>


                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-2">
                                                    <div class="form-group">
                                                        <div class="">
                                                            <mat-form-field appearance="outline"
                                                                class="example-full-width">
                                                                <mat-label> </mat-label>
                                                                <input class="input" matInput readonly
                                                                    formControlName="list2" placeholder="">
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-4">
                                                    <div class="form-group">
                                                        <div class="">
                                                            <mat-form-field appearance="outline"
                                                                class="example-full-width">
                                                                <mat-label> </mat-label>
                                                                <input class="input" matInput readonly
                                                                    formControlName="list3" placeholder="">
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-2">

                                                    <!-- <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label> College</mat-label>
                                                            <mat-select #select22 placeholder="College Name"
                                                                class="colorblack" formControlName="CgCode">
                                                                <mat-select-filter *ngIf="select22.focused"
                                                                    [placeholder]="'College Name'"
                                                                    [displayMember]="'CgName'"
                                                                    [array]="courseClgMapList"
                                                                    (filteredReturn)="filteredstucourseClgMapListList =$event">
                                                                </mat-select-filter>
                                                                <mat-option
                                                                    *ngFor="let item of filteredstucourseClgMapListList"
                                                                    [value]="item.CgCode">
                                                                    {{item.CgCode}} - {{item.CgName}}
                                                                </mat-option>
                                                            </mat-select>
                                                        </mat-form-field> -->

                                                </div>
                                                <div class="col-sm-2">
                                                    <div class="form-group">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label>College</mat-label>
                                                            <mat-select #select2339 placeholder="college"
                                                                class="colorblack" formControlName="CgCode">
                                                                <mat-select-filter *ngIf="select2339.focused"
                                                                    [placeholder]="'Filter'" [displayMember]="'CgName'"
                                                                    [array]="collegeList"
                                                                    (filteredReturn)="filteredCollegeList =$event"></mat-select-filter>
                                                                <mat-option *ngFor="let item of filteredCollegeList"
                                                                    [value]="item.CgCode">
                                                                    {{item.CgCode}} - {{item.CgName}}
                                                                </mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                                <div class="col-sm-2">
                                                    <div class="form-group">
                                                        <div class="">
                                                            <!-- <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label>Valid </mat-label>
                                                            <input class="input" matInput formControlName="Valid"
                                                                placeholder="">
                                                        </mat-form-field> -->
                                                            <mat-form-field appearance="outline"
                                                                class="example-full-width">
                                                                <mat-label>Valid</mat-label>
                                                                <mat-select formControlName="Valid" #select104
                                                                    class="colorblack">
                                                                    <!-- <mat-option>Select</mat-option> -->
                                                                    <mat-option value="Y">Yes</mat-option>
                                                                    <mat-option value="N">No</mat-option>
                                                                </mat-select>
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-2">
                                                    <div class="form-group">
                                                        <div class="">

                                                            <mat-form-field appearance="outline"
                                                                class="example-full-width">
                                                                <mat-label>Change</mat-label>
                                                                <mat-select formControlName="Chng" #select104
                                                                    class="colorblack">
                                                                    <!-- <mat-option>Select</mat-option> -->
                                                                    <mat-option value="Y">Yes</mat-option>
                                                                    <mat-option value="N">No</mat-option>
                                                                </mat-select>
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row col-sm-12">
                                                    <div class="col-sm-12 prpl">
                                                        <button type="button"
                                                            class="btn size1 btn-primary btn-icon-text floatright mt-1 ">

                                                            <span style="display: contents; align-items: center;">
                                                                <img width="15vh" src="../../assets/img/upload.gif"
                                                                    style="margin-right: 7px;">
                                                                Exit
                                                            </span>
                                                        </button>
                                                        <button type="button"
                                                            class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1"
                                                            (click)="ICR()">
                                                            <span style="display: contents; align-items: center;">
                                                                <img width="15vh" src="../../assets/img/list.gif"
                                                                    style="margin-right: 7px;">
                                                                ICR
                                                            </span>
                                                        </button>
                                                        <button type="button" (click)="print()"
                                                            class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1">
                                                            <span style="display: contents; align-items: center;">
                                                                <img width="15vh" src="../../assets/img/printer.gif"
                                                                    style="margin-right: 7px;">
                                                                Print
                                                            </span>
                                                        </button>
                                                        <button type="button"
                                                            class="btn size1 btn-primary btn-icon-text floatright mt-1 mr-3"
                                                            (click)="getList('new')">
                                                            <span style="display: contents; align-items: center;">
                                                                <img width="15vh" src="../../assets/img/search.gif"
                                                                    style="margin-right: 5px;">
                                                                List
                                                            </span>
                                                        </button>




                                                    </div>
                                                </div>

                                            </div>
                                            <hr>
                                            <div class="row clearfix " *ngIf="Table">
                                                <!--  -->
                                                <div class="col-sm-3">
                                                    <div class="form-group">
                                                        <div class="">
                                                            <mat-form-field appearance="outline"
                                                                class="example-full-width">
                                                                <mat-label> Batch</mat-label>
                                                                <input class="input" matInput readonly
                                                                    formControlName="Batch" placeholder="Batch">

                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-4">
                                                    <div class="form-group">
                                                        <mat-form-field appearance="outline"
                                                            class="example-full-width input">
                                                            <mat-label> Rg No</mat-label>
                                                            <mat-select required formControlName="RgNo" #select23
                                                                class="colorblack">
                                                                <mat-select-filter *ngIf="select23.focused"
                                                                    [placeholder]="'Filter'"
                                                                    [displayMember]="'ListDesc'" [array]="ListOfRgNo"
                                                                    (filteredReturn)=" filteredListOfRgNo =$event"></mat-select-filter>
                                                                <mat-option *ngFor="let item of filteredListOfRgNo"
                                                                    [value]="item.RgNo">
                                                                    {{item.RgNo}} - {{item.RgName}}
                                                                </mat-option>
                                                            </mat-select>
                                                            <mat-error class="margin_tp"
                                                                *ngIf="WithHoldForm.controls['RgNo'].touched && WithHoldForm.controls['RgNo'].errors?.required">
                                                                Mandatory
                                                            </mat-error>
                                                        </mat-form-field>
                                                    </div>
                                                </div>

                                                <div class="col-sm-3">
                                                    <div class="form-group">
                                                        <div class="">
                                                            <mat-form-field appearance="outline"
                                                                class="example-full-width">
                                                                <mat-label> Code</mat-label>
                                                                <mat-select required formControlName="Code" #select24
                                                                    class="colorblack">
                                                                    <mat-select-filter *ngIf="select24.focused"
                                                                        [placeholder]="'Filter'"
                                                                        [displayMember]="'ListDesc'" [array]="ListCode"
                                                                        (filteredReturn)="filteredCodeList = $event"></mat-select-filter>
                                                                    <mat-option *ngFor="let item of filteredCodeList"
                                                                        [value]="item.CdCode">
                                                                        {{item.CdCode}}
                                                                        <!-- - {{item.CdDesc}} -->
                                                                    </mat-option>
                                                                </mat-select>
                                                                <mat-error class="margin_tp"
                                                                    *ngIf="WithHoldForm.controls['Code'].touched && WithHoldForm.controls['Code'].errors?.required">
                                                                    Mandatory
                                                                </mat-error>
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-3">
                                                    <div class="form-group">
                                                        <div class="">
                                                            <mat-form-field appearance="outline"
                                                                class="example-full-width">
                                                                <mat-label> Set/Remove</mat-label>
                                                                <mat-select required formControlName="SetRem" #select104
                                                                    class="colorblack">
                                                                    <!-- <mat-option>Select</mat-option> -->
                                                                    <mat-option value="S">Set</mat-option>
                                                                    <mat-option value="R">Remove</mat-option>
                                                                </mat-select>
                                                                <mat-error class="margin_tp"
                                                                    *ngIf="WithHoldForm.controls['SetRem'].touched && WithHoldForm.controls['SetRem'].errors?.required">
                                                                    Mandatory
                                                                </mat-error>
                                                            </mat-form-field>

                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-3">
                                                    <div class="form-group">
                                                        <div class="">
                                                            <mat-form-field appearance="outline"
                                                                class="example-full-width">
                                                                <mat-label> Existing</mat-label>
                                                                <input class="input" matInput readonly
                                                                    formControlName="Existing" placeholder="">
                                                            </mat-form-field>

                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-sm-1">
                                                    <div class="form-group">
                                                        <div class="">
                                                            <mat-form-field appearance="outline"
                                                                class="example-full-width">
                                                                <mat-label> Valid</mat-label>
                                                                <input class="input" matInput readonly
                                                                    formControlName="Valid2" placeholder="">
                                                            </mat-form-field>
                                                            <!-- <mat-form-field appearance="outline"
                                                                class="example-full-width">
                                                                <mat-label>Valid</mat-label>
                                                                <mat-select formControlName="Valid2" #select104
                                                                    class="colorblack">
                                                                    <mat-option value="Y">Yes</mat-option>
                                                                    <mat-option value="N">No</mat-option>
                                                                </mat-select>
                                                            </mat-form-field> -->

                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-4">
                                                    <div class="form-group">
                                                        <div class="">
                                                            <mat-form-field appearance="outline"
                                                                class="example-full-width">
                                                                <mat-label> </mat-label>
                                                                <input class="input" matInput readonly placeholder="">
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                </div>



                                                <div class="table-responsive">
                                                    <table id="datatable" class="table table-bordered text-nowrap">
                                                        <thead>
                                                            <tr class="text-left">

                                                                <th class="f600">
                                                                    Batch
                                                                </th>
                                                                <th class="f600">
                                                                    Regn No
                                                                </th>
                                                                <th class="f600">
                                                                    Code
                                                                </th>
                                                                <th class="f600">
                                                                    Set/Rem
                                                                </th>
                                                                <th class="f600">
                                                                    Existing
                                                                </th>
                                                                <th class="f600">
                                                                    Change
                                                                </th>
                                                                <th class="f600">
                                                                    Valid
                                                                </th>
                                                                <th class="f600">
                                                                    Message
                                                                </th>
                                                                <th class="f600">
                                                                    Action
                                                                </th>

                                                            </tr>
                                                        </thead>
                                                        <tbody id="table_data" formArrayName="WithHoldArray">
                                                            <tr *ngFor="let markData of getWithHoldArrayControls(); let i = index"
                                                                [formGroupName]="i" class="a"
                                                                (click)="prepopulate(markData)">

                                                                <!-- -->
                                                                <td>
                                                                    <!-- {{item.Batch}} -->
                                                                    <input readonly class="tab2 form-control input-sm"
                                                                        formControlName="GridBatch">
                                                                </td>

                                                                <td>
                                                                    <!-- {{item.RgNo}} -->
                                                                    <div>
                                                                        <input readonly
                                                                            class="tab2 form-control input-sm"
                                                                            formControlName="GridRgNo">
                                                                    </div>
                                                                </td>

                                                                <td>
                                                                    <!-- {{item.RgNo}} -->
                                                                    <div>
                                                                        <input readonly
                                                                            class="tab2 form-control input-sm"
                                                                            formControlName="GridCode">
                                                                    </div>
                                                                </td>

                                                                <td>
                                                                    <!-- {{item.RgNo}} -->
                                                                    <div>
                                                                        <input readonly
                                                                            class="tab2 form-control input-sm"
                                                                            formControlName="GridSetRem">
                                                                    </div>
                                                                </td>

                                                                <td>
                                                                    <!-- {{item.RgNo}} -->
                                                                    <div>
                                                                        <input readonly
                                                                            class="tab2 form-control input-sm"
                                                                            formControlName="GridExist">
                                                                    </div>
                                                                </td>

                                                                <td>
                                                                    <!-- {{item.Chng}} -->
                                                                    <input readonly class="tab2 form-control input-sm"
                                                                        formControlName="GridChng">
                                                                </td>
                                                                <td>
                                                                    <!-- {{item.Valid}} -->
                                                                    <input readonly class="tab2 form-control input-sm"
                                                                        formControlName="GridValid">
                                                                </td>
                                                                <td>
                                                                    <!-- {{item.Mesg}} -->
                                                                    <input readonly class="tab2 form-control input-sm"
                                                                        formControlName="GridMesg">
                                                                </td>
                                                                <td>
                                                                    <a class=" ml-2 floating" title="Delete"
                                                                    (click)="delete()"> <i
                                                                            class="fas fa-trash"></i>
                                                                    </a>
                                                                </td>

                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>

                                                <div class="col-sm-12 mb-3">

                                                    <button type="button"
                                                        class="btn size1 btn-primary btn-icon-text floatright mt-1"
                                                        (click)="back()">

                                                        <span style="display: contents; align-items: center;">
                                                            <img width="15vh" src="../../assets/img/upload.gif"
                                                                style="margin-right: 7px;">
                                                            Exit
                                                        </span>
                                                    </button>
                                                    <!-- <button type="button"
                                                        class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1"
                                                        (click)="delete()">
                                                        <span style="display: contents; align-items: center;">
                                                            <img width="15vh" src="../../assets/img/trash.gif"
                                                                style="margin-right: 5px;">
                                                            Delete
                                                        </span>
                                                    </button> -->
                                                    <button type="button"
                                                        class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1"
                                                        (click)="Save()">
                                                        <span style="display: contents; align-items: center;">
                                                            <img width="20vh" src="../../assets/img/save.gif"
                                                                style="margin-right: 5px;">
                                                            Save
                                                        </span>
                                                    </button>
                                                    <button id="New" type="button"
                                                        class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1"
                                                        (click)="addnewrecord()">
                                                        <span style="display: contents; align-items: center;">
                                                            <img width="20vh" src="../../assets/img/plus.gif"
                                                                style="margin-right: 5px;">
                                                            New
                                                        </span>
                                                    </button>

                                                    <!-- <button type="button"
                                                        class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
                                                        (click)="updateMarks()">Update</button>  (click)="delete()"-->

                                                    <!-- <button type="button"
                                                        class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1"
                                                        (click)="update()">
                                                        <span style="display: contents; align-items: center;">
                                                            <img width="15vh" src="../../assets/img/edit1.gif"
                                                                style="margin-right: 7px;">
                                                            Update
                                                        </span>
                                                    </button> -->

                                                    <!-- <button type="button"
                                                            class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
                                                            *ngIf="deleteButton" (click)="DeletetheRecord()">Delete</button> -->
                                                </div>

                                            </div>

                                            <!-- </div> -->
                                        </div>

                                        <!-- <mat-paginator *ngIf="Table" [length]="totalItems" [pageSize]="pageSize"
                                            [pageSizeOptions]="pageSizeOptions"
                                            (page)="onPageChange($event)"></mat-paginator> -->
                                        <div class="col-sm-12 mb-3">

                                            <!-- <button type="button"
                                                class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1"
                                                (click)="updateMultiple()">
                                                <span style="display: contents; align-items: center;">
                                                    <img width="15vh" src="../../assets/img/edit1.gif"
                                                        style="margin-right: 7px;">
                                                    Update
                                                </span>
                                            </button> -->
                                        </div>
                                    </form>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <!-- list of Exam end  -->
            </div>
        </div>
    </div>
</body>